import { render, staticRenderFns } from "./PublicContractorRIDC.vue?vue&type=template&id=06fd73fc&"
import script from "./PublicContractorRIDC.vue?vue&type=script&lang=ts&"
export * from "./PublicContractorRIDC.vue?vue&type=script&lang=ts&"
import style0 from "./PublicContractorRIDC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports